import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Formik, Form } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createSelectOptionSchema } from '../../schema';
import {
  CoverageCheckupState,
  goToNextStep,
  updateCoverageCheckupState,
} from '../../../store/step';
import Select from '@ramsey-design-system/select';
import { FormikFormField } from '@frontman/rt-protections-ui';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';
import { homeAndMortgageRange } from '../../../utils/shared';

function MortgageStep(): ReactElement {
  const dispatch = useDispatch();
  const { mortgageBalance: mortgageBalance } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('owe_on');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader
        header="How much do you owe on your mortgage?"
        subHeader="Just give us your best guess!"
      />
      <Formik
        initialValues={{ mortgageBalance }}
        onSubmit={onSubmit}
        validationSchema={createSelectOptionSchema('mortgageBalance')}
      >
        <Form ref={formRef}>
          <FormikFormField<CoverageCheckupState>
            id="mortgageBalance"
            name="mortgageBalance"
            className="u-spacingBlockMd"
            inputComponent={Select}
            rdsAttributes={{ length: 'lg' }}
          >
            <option value="">Select an Option</option>
            {homeAndMortgageRange.map((option, index) => (
              <option key={index} value={option}>
                {option}
              </option>
            ))}
          </FormikFormField>
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { MortgageStep };
